export default __webpack_public_path__ + "static/media/img_courier.4ca07f6b.jpg";